import requestAPI from "./request";
import PATH_CONFIG from "./path-config";

export default class UserService {

  static getUsersByApp(params) {
    const options = {
      method: "GET",
      params
    };

    return requestAPI(PATH_CONFIG.USERS, options).then(response => {
      return response;
    });
  }

  static getUsersByCriteria(params) {
    const options = {
      method: "GET",
      params
    };

    return requestAPI(PATH_CONFIG.USERS, options).then(response => {
      let numPages = Math.ceil(response.data.total_users / params.per_page);
      return {
        users: response.data.users,
        total_users: response.data.total_users,
        total_pages: numPages,
        start: response.data.start,
        end: response.data.end
      };
    });
  }

  static getUserById(userId) {
    const requestPath = `${PATH_CONFIG.USERS}/${userId}`;
    const options = {
      method: "GET"
    };

    return requestAPI(requestPath, options).then(response => {
      return response;
    });
  }

  static createUser(user) {
    const options = {
      method: "POST",
      data: user
    };

    return requestAPI(PATH_CONFIG.USERS, options).then(response => {
      return response;
    });
  }

  static sendResetPasswordEmail(email) {
    const options = {
      method: "POST",
      data: { email }
    };

    return requestAPI(
      `${PATH_CONFIG.USERS}/reset_password_email`,
      options
    ).then(response => {
      return response;
    });
  }

  static resendVerificationEmail(userId) {
    const options = {
      method: "POST",
      data: { userId }
    };

    return requestAPI(
      `${PATH_CONFIG.USERS}/resend_verification_email`,
      options
    ).then(response => {
      return response;
    });
  }

  static updateUser(userId, user) {
    const requestPath = `${PATH_CONFIG.USERS}/${userId}`;
    const options = {
      method: "PATCH",
      data: user
    };

    return requestAPI(requestPath, options).then(response => {
      return response;
    });
  }

  static getLogsByUserId(userId, queryParams) {
    const requestPath = `${PATH_CONFIG.USERS}/logs/${userId}?page=${
      queryParams.page
    }&per_page=${queryParams.per_page}`;
    const options = {
      method: "GET",
      data: null
    };

    return requestAPI(requestPath, options).then(response => {
      let pagesCount = Math.ceil(response.data.total / queryParams.per_page);

      return {
        logs: response.data.logs,
        pages_count: pagesCount
      };
    });
  }


}



// WEBPACK FOOTER //
// ./src/services/user-service.js